/**
 * Stripe configuration
 * Reads publishable key from environment variables
 */
export const STRIPE_CONFIG = {
  publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
} as const

/**
 * Check if Stripe is properly configured
 */
export const isStripeConfigured = (): boolean => {
  const key = STRIPE_CONFIG.publishableKey.trim()
  return key.startsWith('pk_test_') || key.startsWith('pk_live_')
}
